import { render } from "./StarRatingComponent.vue?vue&type=template&id=710acccc&ts=true"
import script from "./StarRatingComponent.vue?vue&type=script&lang=ts"
export * from "./StarRatingComponent.vue?vue&type=script&lang=ts"

import "./StarRatingComponent.vue?vue&type=style&index=0&id=710acccc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__